import { render, staticRenderFns } from "./Portainer.vue?vue&type=template&id=65419242&scoped=true&"
import script from "./Portainer.vue?vue&type=script&lang=js&"
export * from "./Portainer.vue?vue&type=script&lang=js&"
import style0 from "./Portainer.vue?vue&type=style&index=0&id=65419242&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65419242",
  null
  
)

export default component.exports